import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Colours from '@shared/ui/atoms/Colours';
import { IconTypes } from '@shared/ui/atoms/icon/Icon';
import IconButton from '@shared/ui/molecules/icon-button/IconButton';
import { SimpleSpinner } from '@shared/ui/atoms/SimpleSpinner';
import { UserAvatarAndName } from '@shared/ui/molecules/UserAvatarAndName';
import { useDispatch } from 'react-redux';
import { failureNotification, successNotification } from '@shared/store/notification.duck';
import { UpdateUserField, updateUserField } from '@features/settings/services/UserService';
import { UserInfoV2 } from '@features/settings/pages/manage-users-page-v2/ducks/ManageUsers.model';

interface Props {
  user: UserInfoV2;
  canRemove: boolean;
  onRemoved: (userId: string) => void;
}

export function DepartmentMemberRow(props: Props) {
  const dispatch = useDispatch();
  const [removing, setRemoving] = useState(false);

  const onRemove = async () => {
    if (removing) return;
    setRemoving(true);
    try {
      // Assigning a department of 0 clears the user's department on the backend.
      await updateUserField(props.user.id, UpdateUserField.department, 0);
      dispatch(successNotification('User removed from department'));
      props.onRemoved(props.user.id);
    } catch {
      dispatch(failureNotification('Failed to remove user from department'));
      setRemoving(false);
    }
  };

  return (
    <Row>
      <Link to={`/manage/user/${props.user.id}`} className="noDecoration">
        <UserAvatarAndName colour="blue" firstName={props.user.firstName} lastName={props.user.lastName} />
      </Link>
      {props.canRemove && (
        removing
          ? <SimpleSpinner size={20} />
          : <IconButton icon={IconTypes.Close}
                        color="darkGrey"
                        dataTest="departmentMember-remove"
                        onClick={onRemove} />
      )}
    </Row>
  );
}

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid ${Colours.mildGrey};
  &:last-child {
    border-bottom: none;
  }
`;
